import React, { useEffect, useState } from "react";
import "./NCXComponents.styles.css";
import { DescriptionOutlined, ErrorOutline } from "@mui/icons-material";
import { s360ConfigService } from "../../../Services/S360Config";
import FileIconPdf from "../../../../images/file-type-pdf.svg";
import apiService from "../../../Services/APIService";
import CheckIcon from "@mui/icons-material/Check";

function NCXFileSentMessage(props) {
  const { creator, messageStatus } = props;
  const {
    id,
    url,
    attachedSize,
    attachmentMimeType,
    attachmentTitle,
    attachmentType,
  } = props.mediaData;

  // Get messageStatus and creator from props directly, not from mediaData

  const [resolvedUrl, setResolvedUrl] = useState(false);

  const calculateFileSize = (value) => {
    value = Math.floor(parseFloat(value / 1024));
    const KB_IN_MB = 1024;
    const KB_IN_GB = 1024 * 1024;

    if (value >= KB_IN_GB) {
      return (value / KB_IN_GB).toFixed(2) + " gb";
    } else if (value >= KB_IN_MB) {
      return (value / KB_IN_MB).toFixed(2) + " mb";
    } else {
      return value + " kb";
    }
  };

  const selectFileIcon = (attachmentMimeType) => {
    switch (attachmentMimeType) {
      case "application/pdf":
        return <img src={FileIconPdf} />;
      case "application/msword":
      case "application/vnd.openxmlformats-officedocument.wordprocessingml.document":
      case "text/plain":
      default:
        return (
          <DescriptionOutlined
            fontSize="large"
            sx={{ color: "#7A7D8C" }}
            key={`${id}-filedescriptionoutlined`}
          />
        );
    }
  };

  const isValidImagePreviewUrl = (url) => {
    try {
      const parsedUrl = new URL(url);
      const pathParts = parsedUrl.pathname.split("/");
      const workItemIndex = pathParts.indexOf("workitem");

      const hasCorrectPath =
        workItemIndex > -1 &&
        pathParts[workItemIndex + 2] === "signedurl" &&
        pathParts[1] === "data" &&
        pathParts[2] === "api";

      const hasFilename = parsedUrl.searchParams.has("filename");
      const hasToken = parsedUrl.searchParams.has("token");

      return hasCorrectPath && hasFilename && hasToken;
    } catch (e) {
      return false;
    }
  };

  const extractUrlData = (url) => {
    try {
      const parsedUrl = new URL(url);
      const pathParts = parsedUrl.pathname.split("/");
      const workItemIdIndex = pathParts.indexOf("workitem") + 1;
      const workItemId = pathParts[workItemIdIndex];
      const fileName = parsedUrl.searchParams.get("filename") || "";

      return {
        workItemId,
        fileName,
      };
    } catch (error) {
      console.error("Invalid URL:", error);
      return {
        workItemId: null,
        fileName: null,
      };
    }
  };

  const fetchSignedUrl = async (url) => {
    const { workItemId, fileName } = extractUrlData(url);
    if (workItemId && fileName) {
      const data = await apiService.getMediaUrl(workItemId, fileName);
      setResolvedUrl(data?.data?.signedURL);
    }
  };

  useEffect(() => {
    if (!resolvedUrl && isValidImagePreviewUrl(url)) {
      fetchSignedUrl(url);
    }
  }, []);

  const shouldShowImage =
    attachmentType === "IMAGE" && isValidImagePreviewUrl(url);

  const renderMessageStatus = (isOverlay = false) => {
    const tickColor = isOverlay ? "#fff" : "#666";
    const readColor = "rgb(74, 237, 14)";

    if (s360ConfigService.config?.sandBox) {
      return (
        <div className="s360-message-status">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 448 512"
            style={{
              height: "16px",
              width: "16px",
              color: readColor,
            }}
            fill="currentColor"
          >
            <path d="M337 81c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-143 143L97 127c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l80 80c9.4 9.4 24.6 9.4 33.9 0L337 81zM441 201c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-247 247L41 295c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9L143 465c9.4 9.4 24.6 9.4 33.9 0L441 201z" />
          </svg>
        </div>
      );
    }
    if ((creator === "USER" || creator === "CUSTOMER") && messageStatus) {
      switch (messageStatus) {
        case "SENT":
          return (
            <div className="s360-message-status">
              <CheckIcon
                sx={{
                  color: tickColor,
                  height: "16px",
                  width: "16px",
                }}
              />
            </div>
          );
        case "DELIVERED":
          return (
            <div className="s360-message-status">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 448 512"
                style={{
                  height: "16px",
                  width: "16px",
                  color: tickColor,
                }}
                fill="currentColor"
              >
                <path d="M337 81c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-143 143L97 127c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l80 80c9.4 9.4 24.6 9.4 33.9 0L337 81zM441 201c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-247 247L41 295c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9L143 465c9.4 9.4 24.6 9.4 33.9 0L441 201z" />
              </svg>
            </div>
          );
        case "READ":
          return (
            <div className="s360-message-status">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 448 512"
                style={{
                  height: "16px",
                  width: "16px",
                  color: readColor,
                }}
                fill="currentColor"
              >
                <path d="M337 81c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-143 143L97 127c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l80 80c9.4 9.4 24.6 9.4 33.9 0L337 81zM441 201c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-247 247L41 295c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9L143 465c9.4 9.4 24.6 9.4 33.9 0L441 201z" />
              </svg>
            </div>
          );
        default:
          return null;
      }
    }
    return null;
  };

  return (
    <div
      className={`fileSentMessageStickRight ${
        s360ConfigService?.config?.preview
          ? "fileSentMessageStickRightPreview"
          : "fileSentMessageStickRightWidget"
      }`}
      key={`${id}-fileSentMessageStickRight`}
    >
      {shouldShowImage ? (
        (resolvedUrl || url) && (
          <img
            src={resolvedUrl || url}
            alt={id}
            className="fileSentMessageImg"
            loading="lazy"
            key={`${id}-fileSentMessageImg`}
            onClick={(e) => {
              e.preventDefault();
              const newWindow = window.open();
              if (newWindow) {
                newWindow.opener = null;
                newWindow.location = resolvedUrl || url;
              }
            }}
            style={{ cursor: "pointer" }}
          />
        )
      ) : (
        <>
          <div
            className="fileSentMessageTextContainer"
            key={`${id}-fileSentMessageTextContainer`}
          >
            {selectFileIcon(attachmentMimeType)}
            <div
              className="fileSentMessageTextVertical"
              key={`${id}-fileSentMessageTextVertical`}
            >
              <span
                className="fileSentMessageText"
                key={`${id}-fileSentMessageText`}
              >
                {attachmentTitle}
              </span>
              <span
                className="fileSentMessageTextSize"
                key={`${id}-fileSentMessageTextSize`}
              >
                {calculateFileSize(attachedSize)}
              </span>
            </div>
          </div>
        </>
      )}

      <div className="s360-message-receipt-container">
        {s360ConfigService.config.configDetails.showReadReceipt &&
          renderMessageStatus()}
      </div>
    </div>
  );
}

export default NCXFileSentMessage;
